<template>
	<div>

		<div>
			<!-- BEGIN panel -->
			<div v-show="!notifications.length" class="text-center pt-5">
				<h3> У вас нет уведомлений</h3>
			</div>
			<div v-show="!!notifications.length" class="pb-1">
				<h3>Уведомления:</h3>
			</div>

			<div v-show="!!notifications.length" class="card p-3">
				<div v-for=" (notification, index) in notifications" :key="index"
					@click="$router.push(notification.link).catch(() => { });"
					slyle="background-color: var(--app-component-bg);">
					<div class="d-flex">
						<div class="w-60px">
							<img onerror="javascript:this.src='/assets/img/user/user-5.jpg'" alt=""
								:src="`/images/avatar/` + notification.user.avatar" class="user-avatar" width="50"
								height="50" />
						</div>
						<div class="flex-1 ps-3 cursor-pointer">
							<h5>{{ notification.user.name }}</h5>
							<div>{{ notification.message }}</div>
							<div class="text-muted fs-10px">{{ notification.created_at }}</div>
						</div>
					</div>
					<hr class="bg-gray-500 mb-3">
				</div>

				<Paginator :meta="meta" :fetchData="fetchData" />
			</div>
			<!-- END panel -->
		</div>
	</div>
</template>


<script>
import HTTP from "../http";
import { show_error } from "../message";


export default {
	data() {
		return {
			loading: false,
			notifications: [],
			meta: { last_page: 1 }
		};
	},


	mounted() {
		this.fetchData(this.curr_page);
	},
	methods: {

		fetchData(page) {
			this.loading = true;
			this.$insProgress.start();
			HTTP()
				.get("/notification?page=" + page)
				.then((resp) => {
					console.log('resp1', resp)
					this.notifications = resp.data.data
					this.meta = resp.data.meta
					this.meta.current_page = !this.meta.current_page ? 1 : this.meta.current_page
				})
				.catch((error) => {
					show_error(this.$notify, this.$refs.form, error.response.data)
				})
				.finally(() => {
					this.loading = false;
					this.$insProgress.finish();
				});
		},
	}
}
</script>


<style>
.task-href {
	cursor: pointer;
	text-decoration: none;
	color: var(--bs-body-color);
}

.task-href:visited {
	color: var(--bs-body-color);
}

.task-href:hover {
	color: var(--bs-body-color);
}

.c-sliding-pagination__list-element {
	background-color: white;
}
</style>